exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.order-status[data-v-77328e3a] {\n  width: 1.066667rem;\n  height: 1.066667rem;\n}\n.order-status > img[data-v-77328e3a] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
